export default __webpack_public_path__ + "static/media/nine_of_cups.d2c1c30b.png";